import React from "react";
import Inventory from "../../components/assets/Inventory";

const InventoryManagementPage = () => {
  return (
    <>
      <Inventory />
    </>
  );
};

export default InventoryManagementPage;
